import { z } from 'zod';

export const SubscriptionSchema = z.object({
  plan: z.enum(['SOLO', 'SALON', 'GROWTH']).default('SOLO'),
  isFounder: z.boolean().default(false), // Honorary status
  expiresAt: z.any().nullable(), // The master source of truth for access (Timestamp)
  updatedAt: z.any(), // Audit timestamp
});

export type SubscriptionData = z.infer<typeof SubscriptionSchema>;
